import { render, staticRenderFns } from "./Zuo.vue?vue&type=template&id=5a10035e&"
import script from "./Zuo.vue?vue&type=script&lang=js&"
export * from "./Zuo.vue?vue&type=script&lang=js&"
import style0 from "./Zuo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports